/** Hold time between crossfades after the first transition (ms). */
export const LOADING_CYCLE_MS = 3600;

/** Hold time on slide 1 before the first transition only (ms). */
export const LOADING_INITIAL_CYCLE_MS = 1400;

/** Max wait for image 0 + 1 before starting the carousel timer (ms). */
export const LOADING_READY_GATE_MAX_MS = 400;

/** Overlapping crossfade — outgoing and incoming animate together. */
export const LOADING_CROSSFADE_MS = 300;

export const LOADING_FADE_MS = LOADING_CROSSFADE_MS;

/** Text slide/fade — synced with image crossfade. */
export const LOADING_TEXT_SLIDE_MS = 300;

/** Retry spacing while holding the current image until the next one loads (ms). */
export const LOADING_IMAGE_RETRY_MS = 500;
